import { axiosApi } from './index';
import { types, API_URL } from './types';

export const getBanners = () => {
  const url = `${API_URL}/api/v1/banner`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetBanners(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetBanners(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetBanners({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetBanners = (data) => ({
  type: types.bnrGetBanners,
  payload: data,
});

export const createBanner = (formData) => {
  const url = `${API_URL}/api/v1/banner/create`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setCreateBanner(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setCreateBanner(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        outputData['message'] = 'Error al crear banner';
        dispatch(setCreateBanner(outputData));
      });
  };
};

export const setCreateBanner = (data) => ({
  type: types.bnrCreateBanner,
  payload: data,
});

export const updateBanner = (bannerId, formData) => {
  const url = `${API_URL}/api/v1/banner/edit/${bannerId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .put(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setUpdateBanner(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setUpdateBanner(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        outputData['message'] = 'Error al actualizar banner';
        dispatch(setUpdateBanner(outputData));
      });
  };
};

export const setUpdateBanner = (data) => ({
  type: types.bnrUpdateBanner,
  payload: data,
});

export const deleteBannerById = (bannerId) => {
  const url = `${API_URL}/api/v1/banner/${bannerId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.delete(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setDeleteBannerById(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        outputData['bannerId'] = bannerId;
        dispatch(setDeleteBannerById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setDeleteBannerById({ status: 'danger', error: true, message }));
      });
  };
};

export const setDeleteBannerById = (data) => ({
  type: types.bnrDeleteBannerById,
  payload: data,
});
